import { t } from 'i18next';
import { ObjectSchema } from 'yup';
import Yup from '../../../services/common/validation';
import { Expense, ExpenseDetailsFormModel_PL } from './formModel';

export const getValidationSchema = (): ObjectSchema<ExpenseDetailsFormModel_PL> => {
  const validatePayment = Yup.number()
    .typeError(t('validation:onlyNumbers'))
    .required(t('validation:required'))
    .min(0, t('validation:onlyPositive'));

  const validateExpense: ObjectSchema<Expense> = Yup.object({
    payment: validatePayment,
    sole: Yup.boolean()
      .default(null)
      .when('payment', {
        is: (payment: number) => payment > 0,
        then: (schema) => schema.required(t('validation:required')),
        otherwise: (schema) => schema.notRequired(),
      }),
  });

  const validateExpenseList = Yup.array().of(validateExpense).min(1, 'At least one expense is required').required();

  return Yup.object({
    personalLoan: validateExpenseList,
    carFinance: validateExpenseList,
    creditCards: validateExpenseList,
    otherDebt: validateExpenseList,
    otherCommitments: validateExpenseList,
    mortgage: validateExpenseList,
    total: validatePayment,
  });
};
